import initCarousel from '../../components/carousel';

// Init Carousel on DomContentLoaded
document.addEventListener( 'DOMContentLoaded', () => {
	const featuredRecipes = document.querySelector( '.wp-block-rte-latest-recipes-homepage' );

	if ( ! featuredRecipes ) {
		return;
	}

	const carouselContainer = featuredRecipes.querySelector( '.rte-carousel' );
	initCarousel( carouselContainer );
} );

// Enable HMR
if ( module.hot ) {
	module.hot.accept();
}
